import React, { useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { get_order } from '../../store/reducers/orderReducer'

const Order = () => {

    const { orderId } = useParams()
    const dispatch = useDispatch()
    const { myOrder } = useSelector(state => state.order)
    const { userInfo } = useSelector(state => state.auth)

    useEffect(() => {
        dispatch(get_order(orderId))
    }, [orderId])

    return (
        <div className='bg-white rounded-lg p-5'>
            <h2 className='text-slate-600 font-semibold xs:text-sm'>#{myOrder._id} , <span className='pl-1'>{myOrder.date}</span></h2>
            <div className='grid grid-cols-1 xs:grid-cols-1 gap-3'>
                <div className='flex flex-col gap-1'>
                <div className='border my-3'></div>
                    <h2 className='text-slate-600 font-semibold xs:text-sm'>Deliver to: {myOrder.shippingInfo?.name}</h2>
                    <div className='border my-3'></div>
                    <p>
                        <span className='bg-blue-100 text-blue-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded'>Home</span>
                        <span className='text-slate-600 text-sm'>{myOrder.shippingInfo?.address} {myOrder.shippingInfo?.province} {myOrder.shippingInfo?.city} {myOrder.shippingInfo?.area}</span>
                    </p>
                    <p className='text-slate-600 text-sm font-semibold xs:hidden'>Email to {userInfo.email}</p>
                </div>
                <div className='border my-1'></div>
                <div className='text-slate-600 xs:text-sm'>
                    <h2><span className='font-semibold'>Price:</span> Rs.{myOrder.price} include shipping iee</h2>
                    <p> <span className='font-semibold'>Pyment status: </span><span className={`py-[1px] text-xs px-3 ${myOrder.payment_status === 'paid' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'} rounded-md `}>{myOrder.payment_status}</span></p>
                    <p> <span className='font-semibold'>Order status: </span><span className={`py-[1px] text-xs px-3 ${myOrder.delivery_status !== 'cancelled' ? 'bg-indigo-100 text-indigo-800' : 'bg-red-100 text-red-800'} rounded-md `}>{myOrder.delivery_status}</span></p>
                </div>
            </div>
            <div className='border my-4'></div>
            <div className='mt-3'>
                <h2 className='text-slate-800 text-lg xs:text-base pb-2'>Products</h2>
                <div className='flex gap-5 flex-col'>
                    {
                        myOrder.products?.map((p, i) => <div key={i}>
                            <div className='flex gap-5 justify-between items-center text-slate-600'>
                                <div className='flex gap-2'>
                                    <img className='w-[55px] h-[55px] xs:w-[50px] xs:h-[50px] rounded-lg' src={p.images[0]} alt="image" />
                                    <div className='flex text-sm xs:text-xs flex-col justify-start items-start'>
                                        <Link className=''>{p.name}</Link>

                                        <span>Brand: {p.brand}</span>
                                        <span>Quantity: {p.quantity}</span>

                                    </div>
                                </div>
                                <div className='text-md xs:text-sm'>
                                    {p.discount !== 0 ?
                                        <>
                                            <h2 className=' text-primaryLight'>Rs.{p.price - Math.floor((p.price * p.discount) / 100)}</h2>
                                            <p>-{p.discount}%</p>
                                        </>
                                        :
                                        <p className=' text-primaryLight'>Rs.{p.price}</p>
                                    }
                                </div>
                            </div>
                        </div>)
                    }
                </div>
            </div>
        </div>
    )
}

export default Order